export const SET_MARKET_READINESS_FOR_USER_STORE = 'SET_MARKET_READINESS_FOR_USER_STORE';
export const AUTH_RECEIVED = 'AUTH_RECEIVED';
export const LOG_OUT = 'LOG_OUT';
export const CLEAR_STORES = 'CLEAR_STORES';
export const GET_USER = 'GET_USER';
export const GET_USER_FOR_ADMIN = 'GET_USER_FOR_ADMIN';
export const PROFILE_IMAGE_CHANGED = 'PROFILE_IMAGE_CHANGED';
export const USER_STORE_PLAN_UPDATE = 'USER_STORE_PLAN_UPDATE';
export const ONBOARDING_COMPLETE = 'ONBOARDING_COMPLETE';
export const ADMIN_LOGOUT = 'ADMIN_LOGOUT';
export const UPDATE_UPGRADE_SOURCE = 'UPDATE_UPGRADE_SOURCE';
export const LOG_UPGRADE_CLICK = 'LOG_UPGRADE_CLICK';

// notifications
export const EDIT_NOTIFICATION_STARTING = 'EDIT_NOTIFICATION_STARTING';
export const EDIT_NOTIFICATION_FINISHED = 'EDIT_NOTIFICATION_FINISHED';
export const EDIT_NOTIFICATION_FAILED = 'EDIT_NOTIFICATION_FAILED';

export const UPDATE_USER_PROP = 'UPDATE_USER_PROP';



// WEBPACK FOOTER //
// ./src/app/stores/user/user-constants.js